export enum MonitorSortEnum {
  SortByMonitorTitle = 'MonitorTitle',
  SortByLocationTitle = 'Title'
}
